// The user list is a dictionary keyed by definition ID, not an array.
// Keep summary metadata and untouched rows when loading one full record.
export function mergeUserInstanceDetail(userList, detail) {
  const { Id, UserDefinitionId } = detail.UserInstance;
  const group = userList[UserDefinitionId] || {};
  const rows = group[UserDefinitionId] || [];
  const exists = rows.some((row) => row.UserInstance.Id === Id);
  const updated = exists
    ? rows.map((row) => row.UserInstance.Id === Id ? { ...row, ...detail } : row)
    : [detail, ...rows];
  return { ...userList, [UserDefinitionId]: { ...group, id: UserDefinitionId, [UserDefinitionId]: updated } };
}
